export default __webpack_public_path__ + "static/media/flstudio-logo.293e1efb.svg";